import api from '../api/axios'
import { API_URL } from '../config'
import { CarpetaFotos, FotoBien } from '../types/inventario'

/** Direcciones de los archivos (las pide el navegador con la cookie de sesión: nunca son públicos). */
export const urlFoto = (id: number) => `${API_URL}fotos/${id}/archivo/`
export const urlDescargaFoto = (id: number) => `${API_URL}fotos/${id}/archivo/?descargar=1`
export const urlMiniatura = (id: number) => `${API_URL}fotos/${id}/miniatura/`
/** Todas las fotos del bien en un ZIP, o solo la carpeta que empieza en `periodo`. */
export const urlZipFotos = (bien: number, periodo?: string) =>
  `${API_URL}bienes/${bien}/fotos/zip/${periodo ? `?periodo=${periodo}` : ''}`

/** Las de la ficha por clave (el QR): para cualquier cuenta con sesión. */
export const urlFotoFicha = (clave: string, id: number) => `${API_URL}b/${clave}/fotos/${id}/archivo/`
export const urlMiniaturaFicha = (clave: string, id: number) => `${API_URL}b/${clave}/fotos/${id}/miniatura/`

export const fotoService = {
  carpetas: async (bien: number): Promise<CarpetaFotos[]> =>
    (await api.get<{ carpetas: CarpetaFotos[] }>(`bienes/${bien}/fotos/`)).data.carpetas,
  /** Sube varias a la vez; `alAvanzar` recibe de 0 a 100. */
  subir: async (bien: number, archivos: File[], observacion: string, alAvanzar?: (porcentaje: number) => void): Promise<CarpetaFotos[]> => {
    const datos = new FormData()
    archivos.forEach((a) => datos.append('fotos', a))
    datos.append('observacion', observacion)
    const r = await api.post<{ carpetas: CarpetaFotos[] }>(`bienes/${bien}/fotos/`, datos, {
      onUploadProgress: (e) => alAvanzar?.(e.total ? Math.round((e.loaded / e.total) * 100) : 0),
    })
    return r.data.carpetas
  },
  describir: async (id: number, observacion: string): Promise<FotoBien> => (await api.patch<FotoBien>(`fotos/${id}/`, { observacion })).data,
  eliminar: async (id: number): Promise<void> => {
    await api.delete(`fotos/${id}/`)
  },
}
